import AuthenticatedResource  from 'resources/public/AuthenticatedResource';

// -----------------------------------------------------
// Resource Definition
// -----------------------------------------------------

export default class PageElementResource extends AuthenticatedResource {
  static urlRoot = 'profile/:organization_slug/page_elements';

  readonly id: number | undefined = undefined;

  pk() {
    return this.id?.toString();
  }
}